export default __webpack_public_path__ + "static/media/Wifi - Coral.5d643dd3.svg";